import PropTypes from "prop-types";
import remove from "lodash/remove";
import find from "lodash/find";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const injectCountries = DecoratedComponent => {
	const InjectCountries = props => {
		const { shop } = props;
		const [countries, setCountries] = useState([]);

		useEffect(() => {
			let isMounted = true;
			const [locale, countryCode] = shop.split("-");

			import(`world_countries_lists/data/countries/${locale}/countries.json`)
				.then((countriesModule = []) => {
					// trie par nom de pays
					const finalCountries = [...countriesModule.default].sort((a, b) =>
						a.name.localeCompare(b.name, locale)
					);

					let computedCountries = finalCountries.map(country => {
						country.cca2 = country.alpha2.toUpperCase();
						// do not display "United Kingdom of Great Britain and Northern Ireland"
						if (country.cca2 === "GB") {
							country.name = "United Kingdom";
						}
						return country;
					});

					const currentCountry = find(computedCountries, { cca2: countryCode });

					if (currentCountry) {
						remove(computedCountries, currentCountry);
						computedCountries = [currentCountry, ...computedCountries];
					}

					if (isMounted) {
						setCountries(computedCountries);
					}
				})
				.catch(error => {
					// eslint-disable-next-line no-console
					console.log(error);
					this.props.track("error", { error });
				});

			return () => {
				isMounted = false;
			};
		}, [shop]);

		return <DecoratedComponent {...props} countries={countries} />;
	};

	InjectCountries.propTypes = {
		shop: PropTypes.string,
		track: PropTypes.func,
	};

	const ConnectedInjectCountries = props => {
		const shop = useSelector(state => state.shop);
		const { track } = useAnalytics();
		return <InjectCountries {...props} shop={shop} track={track} />;
	};

	return ConnectedInjectCountries;
};

export default injectCountries;
